import { FC } from 'react'

import { useAProgress } from 'hooks/useAProgress'
import { useSingleEntity } from 'modules/domain/common/hooks'
import * as managers from 'modules/domain/common/managers'
import { RespFile } from 'modules/domain/types'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { useTranslation } from 'react-i18next'
import { Card } from 'views/components/Card/Card'
import AUploadFiles from 'views/components/UploadFiles/AUploadFiles'

interface Props {
  id?: number
}

const TaskFiles: FC<Props> = ({ id }) => {
  const { t } = useTranslation('my_tasks')
  const [progress, files, refetch] = useSingleEntity<RespFile[]>(endpoints.myTasksFiles(id))

  const [, removeFile] = useAProgress((id, fileId: string) => apiClient.delete(endpoints.removeTasksFile(id, fileId)), {
    eventName: 'removeFile',
    onSuccess: refetch,
  })

  const handleAdd = async (file: File) => {
    await managers.uploadFile(endpoints.myTasksFiles(id), file)
    refetch()
  }

  return (
    <Card.GapableContent>
      <Card.Title>{t('detail.documents')}</Card.Title>
      <AUploadFiles
        progress={progress}
        removeFile={(fileId) => removeFile(id, fileId)}
        addFile={({ file }) => handleAdd(file)}
        fileList={files}
      />
    </Card.GapableContent>
  )
}

export default TaskFiles
